module.exports = "https://img.zhijierongxing.com/saas/img/avatar_val.0bfd4809.png";